;(function () {
  if (WC.PageVars && WC.PageVars.contentAssociationsArticleBox) {
    let target = null

    const placeholder = document.querySelector('.cntass-article-box-placeholder')
    if (placeholder) {
      target = placeholder
    } else if (WC.idMenu !== 38) {
      // print after the first .escursioni box (scheda tecnica)
      const escursioni = document.querySelectorAll('.article-full .escursioni') || []
      if (escursioni.length > 0) {
        target = escursioni[0]
      }

      // print after the #dk-trail-cntass-anchor anchor
      const anchor = document.querySelector('.article-full #dk-trail-cntass-anchor')
      if (anchor) {
        target = anchor
      }
    }

    // if we found a target to append to, print cntass
    if (target) {
      printMinisiteArticleLinks(target, WC.PageVars.contentAssociationsArticleBox)
      logView()
    } else {
      console.error('found no target to append cntass')
    }
  }

  function logView() {
    const idMinisiti = WC.PageVars.contentAssociationsArticleBox.flatMap(item =>
      item.links.map(link => link.minisiteId)
    )

    if (!idMinisiti.length) {
      return
    }

    fetch('/visiteminiaturelogger.ashx?type=minisiti', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        idMinisiti,
        idLingua: WC.idLingua,
        idMenu: WC.idMenu,
        idSottoMenu: WC.idSottoMenu,
        idMinisitoOspitante: WC.idCliente,
        idArticolo: WC.idArticolo,
      }),
    })
  }

  function printMinisiteArticleLinks(target, data) {
    data = [...data]
    data.reverse().forEach(item => {
      const mal = document.createElement('div')
      mal.classList.add('minisite-article-links')
      if (WC.idMenu === 38) {
        mal.classList.add('minisite-article-links--wide')
      }
      item.cssClass && mal.classList.add(...item.cssClass.split(' ').filter(item => item?.trim()))

      let linksHTML = ''

      linksHTML = ''
      item.links.forEach(link => {
        linksHTML += `<div data-stati-apertura-chiusura-cnt data-minisite-id="${link.minisiteId}" class="minisite-article-links__cnt">`

        linksHTML += `
					<div class="minisite-article-links__item minisite-article-links__item--title">${link.name}</div>
				`

        linksHTML += `<div class="minisite-article-links__items">`

        if (link.url && link.text) {
          linksHTML += `
						<div class="minisite-article-links__item">
							<a class="minisite-article-links__link" href="${link.url}" target="_blank">
								<span class="minisite-article-links__text">${link.text}</span>
							</a>
						</div>
					`
        }
        if (link.contactUrl && link.contactText) {
          linksHTML += `
						<div class="minisite-article-links__item">
							<a class="minisite-article-links__link" href="${link.contactUrl}" target="_blank">
								<span class="minisite-article-links__text">${link.contactText}</span>
							</a>
						</div>
					`
        }

        linksHTML += `</div>` // minisite-article-links__items

        linksHTML += '</div>' // minisite-article-links__cnt
      })

      function addHtmlDataAttributesMnscntedit(cid, ctype, hasUserContent) {
        let result = []

        if (hasUserContent) {
          result.push('data-cms-user-content')
        }

        if (WC.isWebcloud) {
          result.push(`data-wc-mnscntedit data-wc-cid="${cid}" data-wc-ctype="${ctype}"`)
        }

        return ` ${result.join(' ')} `
      }

      mal.innerHTML = `
				<header class="minisite-article-links__header">
					<h4 class="minisite-article-links__title" ${addHtmlDataAttributesMnscntedit(item.id, 8, false)}>${
        item.title
      }</h4>
				</header>
				<section class="minisite-article-links__copy">
          <img class="minisite-article-links__image" src="${item.imageUrl}" alt="${
        item.imageAlt || ''
      }">
					<div ${addHtmlDataAttributesMnscntedit(item.id, 9, true)}>
            ${item.copy}
          </div>
				</section>
				<div class="minisite-article-links__links">${linksHTML}</div>
			`

      if (WC.isWebcloud) {
        mal.innerHTML = '<div class="admin__var admin__var--cntass">CNTASS</div>' + mal.innerHTML
      }

      target.parentNode.insertBefore(mal, target.nextSibling)
      if (target.classList.contains('cntass-article-box-placeholder')) {
        target.remove()
      }
    })
  }
})()
